import React from 'react';
import {CoreDataLoaders, renderNestedComponents} from 'src/js/common';
import {EnumLoader} from 'src/js/containers/enum';
import {TranslationsLoader} from 'src/js/containers/i18n';

import {PrefetchLoader} from './PrefetchLoader';

type Props = CoreDataLoaders;
export const CoreApplicationDataLoader: React.FC<Props> = (props) => {
  const {children, enums, translations} = props;
  const withTranslations = renderNestedComponents(translations, children, TranslationsLoader);
  const withEnums = renderNestedComponents(enums, withTranslations, EnumLoader);
  return withEnums;
};

CoreApplicationDataLoader.displayName = 'CoreApplicationDataLoader';
